import React, { Component } from "react";
import { connect } from "react-redux";

import { Link } from "react-router-dom";

const LinkRow = ({ href, text }) => {
	return (
		<div style={{ marginBottom: 10, marginLeft: 0 }}>
			<Link style={{ fontSize: "1.1em" }} to={href}>
				{text}
			</Link>
		</div>
	);
};
class SuperAdmin extends Component {
	render() {
		return (
			<div style={{ paddingTop: 20, paddingLeft: 15 }}>
				<div>
					<h3 style={{ fontSize: 20 }}>{`What's New Dropdown`}</h3>
					<LinkRow
						href="/superAdmin/editWhatsNewDropdown"
						text="Edit What's New Dropdown"
					/>
				</div>
				<div style={{ marginTop: 30 }}>
					<h3 style={{ fontSize: 20 }}>Developer</h3>
					<LinkRow
						href="/developer/themeExperiment"
						text="Theme Experiment"
					/>
				</div>
			</div>
		);
	}
}

export default connect(null, {})(SuperAdmin);
